module.exports = __webpack_public_path__ + "img/wiewioreczki-small.c4bdcfc2.jpg";